export const FOOTER_CTA_CLICKED = 'footerCtaClicked'
export const CUSTOM_ACTION_CLICKED = 'customActionClicked'
